export default __webpack_public_path__ + "static/media/sidebar_menu.8a282c0d.svg";